<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div v-show="pagetype === 1">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit.prevent="handleQuery">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24" v-if="!categoryId">
                <a-form-item label="商品分类">
                  <a-select
                    show-search
                    :allowClear="true"
                    v-model="queryParam.categoryId"
                    placeholder="请选择"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                  >
                    <a-select-option v-for="d in cateList" :key="d.id">{{ d.categoryName }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商品名称">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.prodName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商品类型">
                  <a-select
                    show-search
                    :allowClear="true"
                    v-model="queryParam.prodType"
                    placeholder="请选择"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="0">积分</a-select-option>
                    <a-select-option :value="1">金豆</a-select-option>
                    <!-- <a-select-option :value="2">积分/金豆</a-select-option> -->
                    <!-- <a-select-option v-for="d in cateList" :key="d.id">{{ d.categoryName }}</a-select-option> -->
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item label="上架状态">
                    <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                      <a-select-option
                        v-for="(d, index) in dict.type['sys_normal_disable']"
                        :key="index"
                        :value="d.value"
                      >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作 -->
        <div class="table-operations">
          <template v-if="isOperate">
            <a-button
              type="primary"
              @click="$refs.createForm.handleAdd(queryParam.categoryId)"
              v-hasPermi="['abm-integral:prod:add']"
            >
              <a-icon type="plus" />新增
            </a-button>
            <!-- <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['abm-integral:prod:edit']"
          >
            <a-icon type="edit" />修改
          </a-button> -->
            <a-button
              type="danger"
              :disabled="multiple"
              @click="handleDelete"
              v-hasPermi="['abm-integral:prod:remove']"
            >
              <a-icon type="delete" />删除
            </a-button>
          </template>
          <table-setting
            :style="{ float: 'right' }"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList"
          />
        </div>

        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="postId"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="pic" slot-scope="text, record">
            <div v-viewer>
              <img :src="$url + record.pic" alt="" style="width: 50px; height: 50px" />
            </div>
            <!-- <a-avatar :src="$url + record.pic" shape="square" size="large"> </a-avatar> -->
          </span>
          <span slot="putawayTime" slot-scope="text, record">
            {{ parseTime(record.putawayTime) }}
          </span>
          <span slot="prodType" slot-scope="text, record">
            {{ record.prodType == 0 ? '积分' : record.prodType === 1 ? '金豆' : '积分/金豆' }}
          </span>
          <!-- <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_normal_disable']" :value="record.status" />
        </span> -->
          <span slot="pssnums" slot-scope="text, record">
            <div>
              {{ record.prodType == 0 ? '积分' : record.prodType === 1 ? '金豆' : '积分/金豆' }}：{{
                record.scorePrice
              }}
            </div>
            <div>销量：{{ record.soldNum }}</div>
            <div class="" style="color: #1890ff; cursor: pointer">
              <div @click.stop="handleStock(record)">库存：{{ record.totalStocks }}</div>
              <a-input
                v-model="stocks"
                @keyup.enter="handleStocks"
                placeholder="请输入库存"
                v-if="record.isStocks"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></a-input>
            </div>
          </span>
          <span slot="status" slot-scope="text, record">
            <dict-tag :options="dict.type['goods_onsale']" :value="record.status" />
            <template v-if="categoryId">
              <a-tag color="red" v-if="record.status == 0"> 下架 </a-tag>
              <a-tag color="green" v-else> 上架 </a-tag>
            </template>
            <template v-else>
              <a-popconfirm
                ok-text="是"
                cancel-text="否"
                @confirm="confirmHandleStatus(record)"
                @cancel="cancelHandleStatus(record)"
              >
                <span
                  slot="title"
                >确认<b>{{ record.status === 1 ? '下架' : '上架' }}</b
                >吗?</span
                >
                <a-switch
                  checked-children="上架"
                  v-hasPermi="['abm-integral:prod:edit']"
                  un-checked-children="下架"
                  :checked="record.status == 1"
                />
              </a-popconfirm>
            </template>
          </span>
          <span slot="operation" slot-scope="text, record">
            <a
              @click="$refs.createForm.handleUpdate(record, undefined)"
              v-hasPermi="['abm-integral:prod:edit']"
              v-if="record.status == 0"
            >
              修改
            </a>
            <a-divider type="vertical" v-hasPermi="['abm-integral:prod:remove']" v-if="record.status == 0" />
            <a @click="handleDelete(record)" v-hasPermi="['abm-integral:prod:remove']">删除 </a>
            <a-divider type="vertical" v-hasPermi="['abm-integral:prod:query']" />
            <a @click="$refs.goodsDetail.init(record, 1)" v-hasPermi="['abm-integral:prod:query']">详情 </a>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
      <!-- 增加修改 -->
      <!-- <create-pform
        v-show="pagetype === 2"
        ref="CreatePform"
        :statusOptions="dict.type['sys_normal_disable']"
        @ok="getList"
      /> -->
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" :cateList="cateList" />
      <goodsDetail ref="goodsDetail" @ok="getList"></goodsDetail>
    </a-card>
  </page-header-wrapper>
</template>

<script>
// import CreatePform from './modules/CreatePform'
import CreateForm from './modules/CreateForm'
import goodsDetail from './modules/goodsDetail'
// import { tableMixin } from '@/store/table-mixin'
// import * as goods from '@/api/pressure/goods'
import { list } from '@/api/mall/goodscate'
import { categoryList } from '@/api/pressure/goodscate'
import { fetchList, delObj, prodUnmount, prodInventory } from '@/api/pressure/goods'

export default {
  name: 'Post',
  components: {
    // CreatePform,
    CreateForm,
    goodsDetail,
  },
  // mixins: [tableMixin],
  dicts: ['sys_normal_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    categoryId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      dataFrom: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      stocks: '',
      pagetype: 1, // 1商品列表 2新增编辑商品页面
      tableSize: 'small',
      tableBordered: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        categoryId: undefined,
        sortOrder: 'ASCEND',
        sortField: 'sort',
      },
      cateList: [],
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   align: 'center',
        //   width: 50,
        // },
        {
          title: '商品分类',
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'left',
          width: 200,
          scopedSlots: { customRender: 'categoryName' },
        },
        {
          title: '商品名称',
          dataIndex: 'prodName',
          ellipsis: true,
          align: 'left',
          width: 200,
          scopedSlots: { customRender: 'prodName' },
        },
        {
          title: '商品图片',
          dataIndex: 'pic',
          ellipsis: true,
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'pic' },
        },

        {
          title: '商品类型',
          dataIndex: 'prodType',
          ellipsis: true,
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'prodType' },
        },
        // {
        //   title: '价格',
        //   dataIndex: 'price',
        //   align: 'center',
        //   width: 80,
        //   colSpan: 0
        // },
        // {
        //   title: '销量',
        //   dataIndex: 'sales',
        //   align: 'center',
        //   width: 50,
        //   colSpan: 0
        // },
        // {
        //   title: '库存',
        //   dataIndex: 'stock',
        //   align: 'center',
        //   width: 50,
        //   colSpan: 0
        // },
        {
          title: '价格/销量/库存',
          dataIndex: 'pssnums',
          align: 'left',
          width: 120,
          scopedSlots: { customRender: 'pssnums' },
          // colSpan: 3

          // customRender: (value, row, index) => {
          //   const obj = {
          //     children: value,
          //     attrs: {},
          //   };
          //   if (index === 4) {
          //     obj.attrs.rowSpan = 3;
          //   }
          //   // These two are merged into above cell
          //   if (index === 5) {
          //     obj.attrs.rowSpan = 0;
          //   }
          //   if (index === 6) {
          //     obj.attrs.colSpan = 0;
          //   }
          //   return obj;
          // }
        },
        // {
        //   title: '规格',
        //   dataIndex: 'spec_type',
        //   scopedSlots: { customRender: 'spec_type' },
        //   align: 'center',
        //   width: 80,
        // },
        {
          title: '上架状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '上架时间',
          dataIndex: 'putawayTime',
          scopedSlots: { customRender: 'putawayTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.queryParam.categoryId = this.categoryId
    if (this.categoryId) {
      this.columns.pop()
    } else {
      this.getClass()
    }
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 查询商品分类
    getClass() {
      categoryList().then((res) => {
        this.cateList = res.data
      })
    },
    // 点击增加库存
    handleStock(e) {
      // if (this.categoryId) return this.$message.error('没权限进行操作')
      e.isStocks = !e.isStocks
      this.dataFrom = e
      this.$forceUpdate()
    },
    // 回车保存
    handleStocks() {
      if (!this.stocks) return this.$message.error('请输入库存数量')
      prodInventory({ count: this.stocks, id: this.dataFrom.id }).then((res) => {
        this.$message.success('操作成功')
        this.getList()
        this.stocks = ''
      })
    },
    /** 查询商品列表 */
    // getList() {
    //   let response = {
    //     code: '20001',
    //     success: true,
    //     message: '成功.',
    //     data: {
    //       records: [
    //         {
    //           id: 88,
    //           mer_id: 0,
    //           image: 'https://module.niurenjianzhan.com/img/logo.05eadbd7.png',
    //           recommend_image: '',
    //           slider_image: [
    //             'https://module.niurenjianzhan.com/img/logo.05eadbd7.png',
    //             'https://module.niurenjianzhan.com/img/logo.05eadbd7.png',
    //           ],
    //           name: '条香氛无火香薰精油卧室助眠除臭 纯洁100ml',
    //           store_info: '',
    //           keyword: '藤条香氛无火香薰精油卧室助眠',
    //           bar_code: '',
    //           cate_id: '54,22',
    //           price: '52.00',
    //           vip_price: '0.00',
    //           ot_price: '58.00',
    //           postage: '0.00',
    //           unit_name: '瓶',
    //           sort: 1015,
    //           sales: 54,
    //           stock: '122',
    //           is_show: 1,
    //           is_hot: 0,
    //           is_benefit: 0,
    //           is_best: 0,
    //           is_new: 0,
    //           is_virtual: 0,
    //           virtual_type: 0,
    //           add_time: 1636775979,
    //           is_postage: 0,
    //           is_del: 0,
    //           mer_use: 0,
    //           give_integral: '100.00',
    //           cost: '60.00',
    //           is_seckill: 0,
    //           is_bargain: null,
    //           is_good: 0,
    //           is_sub: 0,
    //           is_vip: 0,
    //           ficti: 150,
    //           browse: 0,
    //           code_path: '',
    //           soure_link: '',
    //           temp_id: 0,
    //           spec_type: 1,
    //           activity: '0,3,2,1',
    //           spu: '9810156456732',
    //           label_id: '11,15,18',
    //           video_link: 'http://60.190.250.75:8082/fileserver/-5001/6/3/36/60336.mp4',
    //           command_word: '',
    //           recommend_list: '89,92,94,109',
    //           vip_product: 0,
    //           presale: 0,
    //           presale_start_time: 0,
    //           presale_end_time: 0,
    //           presale_day: 0,
    //           logistics: '2',
    //           freight: 2,
    //           custom_form: '[]',
    //           is_limit: 1,
    //           limit_type: 1,
    //           limit_num: 1,
    //           collect: 48,
    //           likes: 0,
    //           visitor: 1622,
    //           cate_name: '家具软装/居家家具,官方商城/新品上市',
    //           stock_attr: true,
    //           product_type: '普通商品',
    //         },
    //         {
    //           id: 93,
    //           mer_id: 0,
    //           image: 'https://module.niurenjianzhan.com/img/logo.05eadbd7.png',
    //           recommend_image: '',
    //           slider_image: [
    //             'https://module.niurenjianzhan.com/img/logo.05eadbd7.png',
    //             'https://module.niurenjianzhan.com/img/logo.05eadbd7.png',
    //           ],
    //           name: '【LESHUCANGHUA】创意插画动漫人物月野兔SailorMoon水兵月明信片',
    //           store_info: '',
    //           keyword: '',
    //           bar_code: '',
    //           cate_id: '82',
    //           price: '300.00',
    //           vip_price: '0.00',
    //           ot_price: '354.00',
    //           postage: '0.00',
    //           unit_name: '件',
    //           sort: 890,
    //           sales: 45,
    //           stock: '12',
    //           is_show: 1,
    //           is_hot: 0,
    //           is_benefit: 1,
    //           is_best: 0,
    //           is_new: 0,
    //           is_virtual: 0,
    //           virtual_type: 0,
    //           add_time: 1636789299,
    //           is_postage: 0,
    //           is_del: 0,
    //           mer_use: 0,
    //           give_integral: '100.00',
    //           cost: '244.00',
    //           is_seckill: 0,
    //           is_bargain: null,
    //           is_good: 0,
    //           is_sub: 1,
    //           is_vip: 0,
    //           ficti: 0,
    //           browse: 0,
    //           code_path: '',
    //           soure_link: '',
    //           temp_id: 69,
    //           spec_type: 1,
    //           activity: '0,1,2,3',
    //           spu: '5199569781285',
    //           label_id: '7',
    //           video_link: '',
    //           command_word: '',
    //           recommend_list: '',
    //           vip_product: 0,
    //           presale: 0,
    //           presale_start_time: 0,
    //           presale_end_time: 0,
    //           presale_day: 0,
    //           logistics: '1',
    //           freight: 3,
    //           custom_form: '[]',
    //           is_limit: 0,
    //           limit_type: 0,
    //           limit_num: 0,
    //           collect: 35,
    //           likes: 0,
    //           visitor: 1240,
    //           cate_name: '官方商城/vans',
    //           stock_attr: true,
    //           product_type: '普通商品',
    //         },
    //       ],
    //       total: 8,
    //       size: 0,
    //       current: 1,
    //       orders: [],
    //       optimizeCountSql: true,
    //       searchCount: true,
    //       countId: null,
    //       maxLimit: null,
    //       pages: 0,
    //     },
    //     errors: null,
    //     time: '2023-06-02 08:44:03',
    //   }
    //   this.list = response.data.records
    //   this.total = response.data.total
    //   return
    //   // TODO
    //   this.loading = true
    //   goods.list(this.queryParam).then((response) => {
    //     this.list = response.data.records
    //     this.total = response.data.total
    //     this.loading = false
    //   })
    // },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        categoryId: undefined,
        sortOrder: 'ASCEND',
        sortField: 'sort',
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.postId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 新增按钮操作 */
    handleAdd() {
      // this.$router.push({
      //   path: '/pressure/goods/goodsForm',
      //   params: {
      //     id: undefined,
      //     formTitle: '添加商品',
      //   },
      // })
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      const id = row ? row.id : ids
      this.$router.push({
        path: '/mall/goodsForm',
        params: {
          id: id,
          formTitle: '修改商品',
        },
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    confirmHandleStatus(info) {
      prodUnmount({ id: info.id }).then((res) => {
        this.$message.success('操作成功')
        this.getList()
      })
    },
    cancelHandleStatus() {},
  },
}
</script>
